import AddCircleIcon from "@mui/icons-material/AddCircle";
import ChangeCircleIcon from "@mui/icons-material/ChangeCircle";
import { InvitationLog } from "@snubes/snubes-types";
import { useLogListItemProps } from "../helpers/useLogListItemProps";
import { LogListItem } from "../types/LogListItem";
import { LogListItemView } from "./LogListItemView";

export function LogListItemViewForInvitation<T extends InvitationLog>(
  props: LogListItem<T>,
) {
  const restProps = useLogListItemProps(props);
  const { update } = props.log;

  if (update.id) {
    return (
      <LogListItemView
        {...restProps}
        title="Invitation created"
        iconColor="success.main"
        iconComponent={AddCircleIcon}
      />
    );
  }

  return (
    <LogListItemView
      {...restProps}
      title="Invitation edited"
      iconColor="primary.main"
      iconComponent={ChangeCircleIcon}
    />
  );
}
